/**
 * Brutalist Theme — Le Mour
 * Main JavaScript
 */


// ==========================================
// Newsletter Popup
// ==========================================
(function () {
  'use strict';

  const popup = document.querySelector('[data-newsletter-popup]');
  if (!popup) return;

  const STORAGE_KEY = 'brutalist_nl_dismissed';
  const dismissDays = parseInt(popup.dataset.dismissDays || '7');

  // Check if already dismissed
  const dismissed = localStorage.getItem(STORAGE_KEY);
  if (dismissed) {
    const dismissedAt = parseInt(dismissed);
    const now = Date.now();
    const daysSince = (now - dismissedAt) / (1000 * 60 * 60 * 24);
    if (daysSince < dismissDays) return;
  }

  // Check if already subscribed
  if (localStorage.getItem('brutalist_nl_subscribed')) return;

  const delay = parseInt(popup.dataset.delay || '5') * 1000;
  const form = popup.querySelector('[data-newsletter-popup-form]');
  const closeButtons = popup.querySelectorAll('[data-newsletter-popup-close]');
  const successEl = popup.querySelector('[data-newsletter-popup-success]');
  const codeEl = popup.querySelector('[data-newsletter-popup-code]');

  // Show popup after delay
  const showTimer = setTimeout(() => {
    popup.style.display = '';
    document.body.style.overflow = 'hidden';
  }, delay);

  // Close function
  function closePopup() {
    popup.classList.add('is-closing');
    document.body.style.overflow = '';
    localStorage.setItem(STORAGE_KEY, String(Date.now()));

    setTimeout(() => {
      popup.style.display = 'none';
      popup.classList.remove('is-closing');
    }, 350);
  }

  // Close buttons
  closeButtons.forEach(btn => {
    btn.addEventListener('click', closePopup);
  });

  // Close on Escape
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && popup.style.display !== 'none') {
      closePopup();
    }
  });

  // Form submit
  if (form) {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();

      const emailInput = form.querySelector('[data-newsletter-popup-email]');
      const submitBtn = form.querySelector('[data-newsletter-popup-submit]');

      if (!emailInput.value) return;

      if (submitBtn) submitBtn.disabled = true;

      try {
        const formData = new FormData(form);

        const response = await fetch('/contact#contact_form', {
          method: 'POST',
          body: formData,
          headers: { 'Accept': 'text/html' },
        });

        // Show success state regardless
        form.style.display = 'none';
        if (successEl) successEl.style.display = '';

        localStorage.setItem('brutalist_nl_subscribed', 'true');

        // Copy code on click
        if (codeEl) {
          codeEl.addEventListener('click', () => {
            const code = codeEl.textContent.trim();
            navigator.clipboard.writeText(code).then(() => {
              const origText = codeEl.textContent;
              codeEl.textContent = 'KOPIERT ✓';
              setTimeout(() => {
                codeEl.textContent = origText;
              }, 2000);
            });
          });
        }

      } catch (err) {
        console.error('Newsletter submit error:', err);
        if (submitBtn) submitBtn.disabled = false;
      }
    });
  }
})();

(function () {
  'use strict';

  // ==========================================
  // Mobile Menu
  // ==========================================
  const menuToggle = document.querySelector('[data-menu-toggle]');
  const menuClose = document.querySelector('[data-menu-close]');
  const mobileMenu = document.querySelector('[data-mobile-menu]');

  let menuScrollPos = 0;

  if (menuToggle && mobileMenu) {
    menuToggle.addEventListener('click', () => {
      menuScrollPos = window.scrollY;
      document.body.style.top = `-${menuScrollPos}px`;
      document.body.classList.add('menu-open');
      mobileMenu.classList.add('is-open');
    });
  }

  if (menuClose && mobileMenu) {
    menuClose.addEventListener('click', () => {
      mobileMenu.classList.remove('is-open');
      document.body.classList.remove('menu-open');
      document.body.style.top = '';
      window.scrollTo(0, menuScrollPos);
    });
  }

  // ==========================================
  // Cart Drawer Toggle
  // ==========================================
  const cartToggle = document.querySelectorAll('[data-cart-toggle]');
  const cartDrawer = document.querySelector('[data-cart-drawer]');
  const cartClose = document.querySelector('[data-cart-close]');
  const cartOverlay = document.querySelector('[data-cart-overlay]');

  function openCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.add('is-open');
    if (cartOverlay) cartOverlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function closeCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('is-open');
    if (cartOverlay) cartOverlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  // Refresh cart drawer content via Section Rendering API
  async function refreshCartDrawer() {
    try {
      const response = await fetch('/?sections=cart-drawer');
      if (!response.ok) return;
      const data = await response.json();
      const html = data['cart-drawer'];
      if (!html) return;

      // Parse new HTML
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const newDrawer = doc.querySelector('[data-cart-drawer]');
      const newOverlay = doc.querySelector('[data-cart-overlay]');

      if (newDrawer && cartDrawer) {
        cartDrawer.innerHTML = newDrawer.innerHTML;

        // Re-bind close button
        const newCloseBtn = cartDrawer.querySelector('[data-cart-close]');
        if (newCloseBtn) {
          newCloseBtn.addEventListener('click', closeCartDrawer);
        }
      }

      // Update header cart counts from freshly fetched HTML
      const cartResponse = await fetch('/cart.js');
      const cart = await cartResponse.json();
      document.querySelectorAll('[data-cart-count]').forEach(el => {
        el.textContent = cart.item_count;
      });
      document.querySelectorAll('[data-cart-count-text]').forEach(el => {
        el.textContent = cart.item_count;
      });

      // Re-initialize cart-drawer.js quantity listeners
      if (typeof window.initCartDrawerListeners === 'function') {
        window.initCartDrawerListeners();
      }
    } catch (err) {
      console.error('Failed to refresh cart drawer:', err);
    }
  }

  // Expose globally for use from cart-drawer.js
  window.refreshCartDrawer = refreshCartDrawer;

  cartToggle.forEach(btn => btn.addEventListener('click', () => {
    // Close mobile menu first if open
    if (mobileMenu && mobileMenu.classList.contains('is-open')) {
      mobileMenu.classList.remove('is-open');
      document.body.classList.remove('menu-open');
      document.body.style.top = '';
      window.scrollTo(0, menuScrollPos);
    }
    openCartDrawer();
  }));
  if (cartClose) cartClose.addEventListener('click', closeCartDrawer);
  if (cartOverlay) cartOverlay.addEventListener('click', closeCartDrawer);

  // Close on Escape
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      closeCartDrawer();
      if (mobileMenu) {
        mobileMenu.classList.remove('is-open');
        document.body.style.overflow = '';
      }
    }
  });

  // ==========================================
  // Product Image Slider (Mobile only)
  // Desktop: images stack vertically, no slider
  // ==========================================
  const slider = document.querySelector('[data-product-slider]');
  const isMobileSlider = () => window.innerWidth < 768;

  if (slider) {
    const track = slider.querySelector('[data-product-slider-track]');
    const slides = slider.querySelectorAll('.product-page__slide');
    const prevBtn = slider.querySelector('[data-slider-prev]');
    const nextBtn = slider.querySelector('[data-slider-next]');
    const dots = slider.querySelectorAll('[data-slider-dot]');
    const currentEl = slider.querySelector('[data-slider-current]');
    const thumbs = document.querySelectorAll('[data-product-thumb]');
    const totalSlides = slides.length;
    let currentIndex = 0;

    // Drag state
    let isDragging = false;
    let startX = 0;
    let startY = 0;
    let currentTranslate = 0;
    let prevTranslate = 0;
    let dragDelta = 0;
    let isHorizontalSwipe = null; // null = undecided, true/false once determined
    const DRAG_THRESHOLD = 50;
    const DIRECTION_LOCK_THRESHOLD = 5;

    function goToSlide(index, animate = true) {
      if (!isMobileSlider()) return;
      if (index < 0) index = totalSlides - 1;
      if (index >= totalSlides) index = 0;
      currentIndex = index;

      const offset = -(currentIndex * 100);
      track.style.transition = animate ? 'transform 0.5s cubic-bezier(0.16, 1, 0.3, 1)' : 'none';
      track.style.transform = `translateX(${offset}%)`;
      prevTranslate = offset;

      // Update counter
      if (currentEl) {
        currentEl.textContent = String(currentIndex + 1).padStart(2, '0');
      }

      // Update dots
      dots.forEach((dot, i) => {
        dot.classList.toggle('is-active', i === currentIndex);
      });

      // Update thumbnails
      thumbs.forEach((thumb, i) => {
        thumb.classList.toggle('is-active', i === currentIndex);
      });
    }

    // Button controls (mobile only)
    if (prevBtn) prevBtn.addEventListener('click', () => goToSlide(currentIndex - 1));
    if (nextBtn) nextBtn.addEventListener('click', () => goToSlide(currentIndex + 1));

    // Dot controls
    dots.forEach(dot => {
      dot.addEventListener('click', () => {
        goToSlide(parseInt(dot.dataset.sliderDot));
      });
    });

    // Keyboard (mobile)
    slider.setAttribute('tabindex', '0');
    slider.addEventListener('keydown', (e) => {
      if (!isMobileSlider()) return;
      if (e.key === 'ArrowLeft') goToSlide(currentIndex - 1);
      if (e.key === 'ArrowRight') goToSlide(currentIndex + 1);
    });

    // --- Drag / Swipe (Mobile only) ---
    function getClientX(e) {
      return e.touches ? e.touches[0].clientX : e.clientX;
    }

    function getClientY(e) {
      return e.touches ? e.touches[0].clientY : e.clientY;
    }

    function onDragStart(e) {
      if (!isMobileSlider()) return;
      if (totalSlides <= 1) return;
      isDragging = true;
      startX = getClientX(e);
      startY = getClientY(e);
      dragDelta = 0;
      isHorizontalSwipe = null; // Reset direction lock
      track.style.transition = 'none';
      slider.style.cursor = 'grabbing';
    }

    function onDragMove(e) {
      if (!isDragging) return;
      const currentX = getClientX(e);
      const currentY = getClientY(e);
      const deltaX = currentX - startX;
      const deltaY = currentY - startY;

      // Determine swipe direction once we pass the threshold
      if (isHorizontalSwipe === null && (Math.abs(deltaX) > DIRECTION_LOCK_THRESHOLD || Math.abs(deltaY) > DIRECTION_LOCK_THRESHOLD)) {
        isHorizontalSwipe = Math.abs(deltaX) > Math.abs(deltaY);
      }

      // If vertical swipe, don't interfere — let the page scroll
      if (isHorizontalSwipe === false) return;

      // Horizontal swipe — prevent page scrolling
      if (isHorizontalSwipe && e.cancelable) {
        e.preventDefault();
      }

      dragDelta = deltaX;
      const sliderWidth = slider.offsetWidth;
      const dragPercent = (dragDelta / sliderWidth) * 100;
      const offset = -(currentIndex * 100) + dragPercent;
      track.style.transform = `translateX(${offset}%)`;
    }

    function onDragEnd() {
      if (!isDragging) return;
      isDragging = false;
      isHorizontalSwipe = null;
      slider.style.cursor = 'grab';

      if (Math.abs(dragDelta) > DRAG_THRESHOLD) {
        if (dragDelta < 0) {
          goToSlide(currentIndex + 1);
        } else {
          goToSlide(currentIndex - 1);
        }
      } else {
        goToSlide(currentIndex);
      }
    }

    // Mouse events (mobile only via CSS pointer control)
    slider.addEventListener('mousedown', onDragStart);
    slider.addEventListener('mousemove', onDragMove);
    slider.addEventListener('mouseup', onDragEnd);
    slider.addEventListener('mouseleave', () => {
      if (isDragging) onDragEnd();
    });

    // Touch events
    slider.addEventListener('touchstart', onDragStart, { passive: true });
    slider.addEventListener('touchmove', onDragMove, { passive: false });
    slider.addEventListener('touchend', onDragEnd);

    // Reset transform when switching to desktop
    window.addEventListener('resize', () => {
      if (!isMobileSlider()) {
        track.style.transform = '';
        track.style.transition = '';
      }
    });
  }

  // ==========================================
  // Product Page — Variant Selection
  // ==========================================
  const productSection = document.querySelector('[data-product]');

  if (productSection) {
    const productJson = productSection.querySelector('[data-product-json]');
    const productData = productJson ? JSON.parse(productJson.textContent) : null;
    const variantIdInput = productSection.querySelector('[data-variant-id]');
    const optionButtons = productSection.querySelectorAll('[data-option-value]');
    const addToCartBtn = productSection.querySelector('[data-add-to-cart]');
    const priceEl = productSection.querySelector('[data-product-price]');

    // Low Stock elements
    const lowStockEl = productSection.querySelector('[data-low-stock]');
    const stockCountEl = productSection.querySelector('[data-stock-count]');
    const inventoryJsonEl = productSection.querySelector('[data-variant-inventory]');
    const inventoryData = inventoryJsonEl ? JSON.parse(inventoryJsonEl.textContent) : {};
    window.__variantInventory = inventoryData;

    // Low Stock update function — uses dedicated inventory JSON from Liquid
    function updateLowStock(variant) {
      if (!lowStockEl || !stockCountEl) return;
      const qty = variant ? inventoryData[String(variant.id)] : null;
      if (qty != null && qty > 0 && qty <= 5) {
        stockCountEl.textContent = qty;
        lowStockEl.style.display = '';
      } else {
        lowStockEl.style.display = 'none';
      }
    }

    // Check if selected variant is already maxed out in cart
    const arrowSvg = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M4.5 12h15m0 0l-6.75-6.75M19.5 12l-6.75 6.75"/></svg>';

    function checkCartForVariant(cart) {
      if (!addToCartBtn || !variantIdInput) return;
      const selectedVariantId = parseInt(variantIdInput.value);
      const maxStock = inventoryData[String(selectedVariantId)];

      // If no inventory data or untracked, allow adding
      if (maxStock == null || maxStock === 0) return;

      // Check if this variant is in the cart at max quantity
      const cartItem = cart.items.find(item => item.variant_id === selectedVariantId);
      if (cartItem && cartItem.quantity >= maxStock) {
        addToCartBtn.disabled = true;
        addToCartBtn.innerHTML = 'Bereits im Warenkorb';
      }
    }

    // Re-check when cart changes (called from cart-drawer.js)
    window.checkCartForVariant = function(cart) {
      if (!addToCartBtn || !variantIdInput) return;
      const selectedVariantId = parseInt(variantIdInput.value);
      const maxStock = inventoryData[String(selectedVariantId)];

      if (maxStock == null) return;

      const cartItem = cart.items.find(item => item.variant_id === selectedVariantId);
      if (cartItem && cartItem.quantity >= maxStock) {
        addToCartBtn.disabled = true;
        addToCartBtn.innerHTML = 'Bereits im Warenkorb';
      } else {
        // Re-enable if variant was removed from cart or qty reduced
        // But only if the variant is actually available
        if (productData) {
          const variant = productData.variants.find(v => v.id === selectedVariantId);
          if (variant && variant.available) {
            addToCartBtn.disabled = false;
            addToCartBtn.innerHTML = 'In den Warenkorb ' + arrowSvg;
          }
        }
      }
    };

    if (productData && optionButtons.length > 0) {
      // Track selected options
      const selectedOptions = {};
      productData.options.forEach((option, i) => {
        const activeBtn = productSection.querySelector(
          `[data-option-position="${i + 1}"].is-selected`
        );
        if (activeBtn) {
          selectedOptions[i + 1] = activeBtn.dataset.value;
        }
      });

      optionButtons.forEach(btn => {
        btn.addEventListener('click', () => {
          const position = parseInt(btn.dataset.optionPosition);
          const value = btn.dataset.value;

          // Update selected state
          selectedOptions[position] = value;
          const siblings = productSection.querySelectorAll(
            `[data-option-position="${position}"]`
          );
          siblings.forEach(s => s.classList.remove('is-selected'));
          btn.classList.add('is-selected');

          // Update label
          const label = productSection.querySelector(
            `[data-option-selected="${position}"]`
          );
          if (label) label.textContent = value;

          // Find matching variant
          const selectedValues = Object.values(selectedOptions);
          const variant = productData.variants.find(v => {
            return v.options.every((opt, i) => opt === selectedValues[i]);
          });

          if (variant) {
            // Update hidden input
            if (variantIdInput) variantIdInput.value = variant.id;

            // Update price
            if (priceEl) {
              const taxNote = '<span class="product-page__tax-note">inkl. MwSt.</span>';
              if (variant.compare_at_price && variant.compare_at_price > variant.price) {
                priceEl.className = 'product-page__price product-page__price--sale';
                priceEl.innerHTML = `
                  <span class="price--regular">${formatMoney(variant.compare_at_price)}</span>
                  <span class="price--sale">${formatMoney(variant.price)}</span>
                  ${taxNote}
                `;
              } else {
                priceEl.className = 'product-page__price';
                priceEl.innerHTML = `<span>${formatMoney(variant.price)}</span>${taxNote}`;
              }
            }

            // Update add to cart button
            if (addToCartBtn) {
              if (variant.available) {
                addToCartBtn.disabled = false;
                addToCartBtn.innerHTML = 'In den Warenkorb ' + arrowSvg;

                // Check if this variant is already maxed out in cart
                const maxStock = inventoryData[String(variant.id)];
                if (maxStock != null && maxStock > 0) {
                  fetch('/cart.js').then(r => r.json()).then(cart => {
                    const cartItem = cart.items.find(item => item.variant_id === variant.id);
                    if (cartItem && cartItem.quantity >= maxStock) {
                      addToCartBtn.disabled = true;
                      addToCartBtn.innerHTML = 'Bereits im Warenkorb';
                    }
                  }).catch(() => {});
                }
              } else {
                addToCartBtn.disabled = true;
                addToCartBtn.innerHTML = 'Ausverkauft';
              }
            }

            // Update low stock warning
            updateLowStock(variant);

            // Update URL
            const url = new URL(window.location);
            url.searchParams.set('variant', variant.id);
            window.history.replaceState({}, '', url);

            // Update main image to variant image
            if (variant.featured_image) {
              const sliderTrack = document.querySelector('[data-product-slider-track]');
              if (sliderTrack) {
                const slideImgs = sliderTrack.querySelectorAll('.product-page__slide img');
                slideImgs.forEach((img, i) => {
                  if (img.src.includes(variant.featured_image.src.split('?')[0].split('/').pop())) {
                    if (window.innerWidth < 768) {
                      // Mobile: go to that slide
                      const goToSlide = window.__brutalistSliderGoTo;
                      if (typeof goToSlide === 'function') goToSlide(i);
                    } else {
                      // Desktop: scroll to the image
                      const targetSlide = sliderTrack.querySelectorAll('.product-page__slide')[i];
                      if (targetSlide) {
                        targetSlide.scrollIntoView({ behavior: 'smooth', block: 'start' });
                      }
                    }
                  }
                });
              }
            }
          }
        });
      });
    }
  }

  // ==========================================
  // Collection — Sort
  // ==========================================
  const sortSelect = document.querySelector('[data-sort-select]');
  if (sortSelect) {
    sortSelect.addEventListener('change', () => {
      const url = new URL(window.location);
      url.searchParams.set('sort_by', sortSelect.value);
      window.location = url.toString();
    });
  }

  // ==========================================
  // Quick Add to Cart (AJAX)
  // ==========================================
  document.querySelectorAll('.product-card__quick-add[type="submit"]').forEach(btn => {
    btn.closest('form')?.addEventListener('submit', async (e) => {
      e.preventDefault();
      const form = e.target;
      const formData = new FormData(form);

      btn.textContent = '...';

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          body: formData,
        });

        if (response.ok) {
          btn.textContent = '✓';

          // Refresh drawer content, then open
          await refreshCartDrawer();
          openCartDrawer();

          setTimeout(() => {
            btn.textContent = '+ Warenkorb';
          }, 2000);
        } else {
          btn.textContent = 'Fehler';
          setTimeout(() => {
            btn.textContent = '+ Warenkorb';
          }, 2000);
        }
      } catch (err) {
        console.error('Add to cart error:', err);
        btn.textContent = '+ Warenkorb';
      }
    });
  });

  // ==========================================
  // Product Page — AJAX Add to Cart
  // ==========================================
  const productForm = document.querySelector('[data-product-form]');
  if (productForm) {
    productForm.addEventListener('submit', async (e) => {
      e.preventDefault();
      const variantId = productForm.querySelector('[data-variant-id]').value;
      const submitBtn = productForm.querySelector('[data-add-to-cart]');

      if (submitBtn) submitBtn.textContent = 'Wird hinzugefügt...';

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items: [{ id: parseInt(variantId), quantity: 1 }]
          }),
        });

        if (response.ok) {
          if (submitBtn) submitBtn.innerHTML = 'Hinzugefügt ✓';

          // Refresh drawer content, then open
          await refreshCartDrawer();
          openCartDrawer();

          // Check if variant is now maxed out in cart
          try {
            const cartRes = await fetch('/cart.js');
            const cartData = await cartRes.json();
            const selectedVid = parseInt(variantId);
            const maxStock = window.__variantInventory ? window.__variantInventory[String(selectedVid)] : null;
            const cartItem = cartData.items.find(item => item.variant_id === selectedVid);

            if (maxStock != null && cartItem && cartItem.quantity >= maxStock) {
              // Variant is maxed — keep button disabled
              if (submitBtn) submitBtn.innerHTML = 'Bereits im Warenkorb';
            } else {
              setTimeout(() => {
                if (submitBtn) {
                  submitBtn.innerHTML = 'In den Warenkorb <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M4.5 12h15m0 0l-6.75-6.75M19.5 12l-6.75 6.75"/></svg>';
                }
              }, 2000);
            }
          } catch (cartErr) {
            // Fallback: re-enable after delay
            setTimeout(() => {
              if (submitBtn) {
                submitBtn.innerHTML = 'In den Warenkorb <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M4.5 12h15m0 0l-6.75-6.75M19.5 12l-6.75 6.75"/></svg>';
              }
            }, 2000);
          }
        }
      } catch (err) {
        console.error('Add to cart error:', err);
        if (submitBtn) submitBtn.textContent = 'In den Warenkorb';
      }
    });
  }

  // ==========================================
  // Social Proof — Viewer Count
  // ==========================================
  const viewerCountEl = document.querySelector('[data-viewer-count]');
  if (viewerCountEl) {
    const productTitleEl = document.querySelector('.product-page__title');
    const seed = productTitleEl ? productTitleEl.textContent.trim().length : 5;
    const baseViewers = Math.max(2, (seed % 5) + 2); // 2–6 range
    let currentViewers = baseViewers;
    viewerCountEl.textContent = currentViewers;

    function fluctuateViewers() {
      const change = Math.random() < 0.5 ? -1 : 1;
      currentViewers = Math.max(1, Math.min(baseViewers + 3, currentViewers + change));
      viewerCountEl.textContent = currentViewers;
      var nextUpdate = 5000 + Math.random() * 5000;
      setTimeout(fluctuateViewers, nextUpdate);
    }
    setTimeout(fluctuateViewers, 6000 + Math.random() * 4000);
  }

  // ==========================================
  // Shipping Countdown
  // ==========================================
  const shippingCountdown = document.querySelector('[data-shipping-countdown]');
  if (shippingCountdown) {
    const shippingText = shippingCountdown.querySelector('[data-shipping-text]');
    function updateShippingCountdown() {
      const now = new Date();
      const cutoff = new Date(now);
      cutoff.setHours(14, 0, 0, 0);

      if (now < cutoff) {
        const diff = cutoff - now;
        const hrs = Math.floor(diff / 3600000);
        const mins = Math.floor((diff % 3600000) / 60000);
        const secs = Math.floor((diff % 60000) / 1000);
        const pad = (n) => String(n).padStart(2, '0');
        shippingText.innerHTML = 'Bestelle in <strong>' + pad(hrs) + ':' + pad(mins) + ':' + pad(secs) + '</strong> — Versand heute, in 2–5 Tagen bei dir';
      } else {
        shippingText.innerHTML = 'Heute bestellt — <strong>in 2–5 Tagen bei dir</strong>';
      }
    }
    updateShippingCountdown();
    setInterval(updateShippingCountdown, 1000);
  }

  // ==========================================
  // Share — Copy URL
  // ==========================================
  const copyUrlBtn = document.querySelector('[data-copy-url]');
  if (copyUrlBtn) {
    copyUrlBtn.addEventListener('click', () => {
      navigator.clipboard.writeText(window.location.href).then(() => {
        copyUrlBtn.classList.add('product-page__share-btn--copied');
        const originalSvg = copyUrlBtn.innerHTML;
        copyUrlBtn.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>';
        setTimeout(() => {
          copyUrlBtn.innerHTML = originalSvg;
          copyUrlBtn.classList.remove('product-page__share-btn--copied');
        }, 1500);
      });
    });
  }

  // ==========================================
  // Back-in-Stock Notification
  // ==========================================
  const notifyForm = document.querySelector('[data-notify-form]');
  if (notifyForm) {
    const notifyWrapper = document.querySelector('[data-notify-wrapper]');
    const notifyEmail = notifyForm.querySelector('[data-notify-email]');
    const notifySubmit = notifyForm.querySelector('[data-notify-submit]');
    const notifySuccess = document.querySelector('[data-notify-success]');
    const notifyProductInput = notifyForm.querySelector('[data-notify-product]');

    notifyForm.addEventListener('submit', async (e) => {
      e.preventDefault();

      const email = notifyEmail.value.trim();
      if (!email) return;

      notifySubmit.disabled = true;
      notifySubmit.textContent = '...';

      try {
        const formData = new FormData();
        formData.append('form_type', 'contact');
        formData.append('utf8', '✓');
        formData.append('contact[email]', email);
        formData.append('contact[body]', notifyProductInput.value);
        formData.append('contact[tags]', 'back-in-stock');

        const response = await fetch('/contact#contact_form', {
          method: 'POST',
          body: formData,
          headers: {
            'Accept': 'application/json'
          }
        });

        // Show success regardless (Shopify may redirect)
        notifyForm.style.display = 'none';
        if (notifySuccess) notifySuccess.classList.add('is-visible');
      } catch (err) {
        // Show success anyway — form was likely submitted
        notifyForm.style.display = 'none';
        if (notifySuccess) notifySuccess.classList.add('is-visible');
      }
    });

    // Show/hide notify form based on variant availability
    if (productSection) {
      const addToCartBtn = productSection.querySelector('[data-add-to-cart]');
      const observer = new MutationObserver(() => {
        if (addToCartBtn && addToCartBtn.disabled) {
          notifyWrapper.classList.add('is-visible');
        } else {
          notifyWrapper.classList.remove('is-visible');
          // Reset form state
          notifyForm.style.display = '';
          if (notifySuccess) notifySuccess.classList.remove('is-visible');
          notifySubmit.disabled = false;
          notifySubmit.textContent = 'Senden';
        }
      });

      if (addToCartBtn) {
        observer.observe(addToCartBtn, { attributes: true, attributeFilter: ['disabled'] });
      }
    }
  }

  // ==========================================
  // Utility: Format money (Shopify cents)
  // ==========================================
  function formatMoney(cents) {
    const amount = (cents / 100).toFixed(2).replace('.', ',');
    return `€${amount}`;
  }

  // ==========================================
  // Product Description Parser
  // ==========================================
  const descContainer = document.querySelector('[data-product-description]');
  if (descContainer) {
    parseProductDescription(descContainer);
  }

  function parseProductDescription(container) {
    // Get the raw HTML and extract text content
    const rawHTML = container.innerHTML.trim();

    // Create a temporary element to parse the HTML
    const temp = document.createElement('div');
    temp.innerHTML = rawHTML;

    // Extract text lines from the HTML (handle <p>, <br>, plain text)
    const lines = [];
    const childNodes = temp.childNodes;

    function extractLines(node) {
      if (node.nodeType === Node.TEXT_NODE) {
        const text = node.textContent.trim();
        if (text) {
          text.split('\n').forEach(line => {
            const trimmed = line.trim();
            if (trimmed) lines.push(trimmed);
          });
        }
      } else if (node.nodeType === Node.ELEMENT_NODE) {
        const tag = node.tagName.toLowerCase();
        if (tag === 'br') {
          // br just creates line breaks, handled by parent
          return;
        }
        if (tag === 'ul' || tag === 'ol') {
          // Already a list — keep as-is
          const listItems = node.querySelectorAll('li');
          listItems.forEach(li => {
            const text = li.textContent.trim();
            if (text) lines.push(text);
          });
          return;
        }
        if (['p', 'div', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6'].includes(tag)) {
          // Get inner HTML and split by <br>
          const innerParts = node.innerHTML.split(/<br\s*\/?>/gi);
          innerParts.forEach(part => {
            const span = document.createElement('span');
            span.innerHTML = part;
            const text = span.textContent.trim();
            if (text) lines.push(text);
          });
          return;
        }
        // For other elements, recurse
        node.childNodes.forEach(child => extractLines(child));
      }
    }

    childNodes.forEach(child => extractLines(child));

    if (lines.length === 0) return;

    // Identify headings: short lines ending with ":" or known keywords
    const headingPatterns = [
      /^produkt\s*details?$/i,
      /^details?$/i,
      /^waschhinweise:?$/i,
      /^pflegehinweise:?$/i,
      /^material:?$/i,
      /^infos?:?$/i,
      /^informationen:?$/i,
      /^hinweise?:?$/i,
      /^größen?:?$/i,
      /^passform:?$/i,
      /^features?:?$/i,
      /^beschreibung:?$/i,
    ];

    function isHeading(line) {
      // Check against known patterns
      for (const pattern of headingPatterns) {
        if (pattern.test(line)) return true;
      }
      // Short line ending with ":" is likely a heading
      if (line.length < 30 && line.endsWith(':')) return true;
      return false;
    }

    function isInfoNote(line) {
      // Lines that start with "Das Model" or "Unser Model" etc
      return /^(das|unser|die|der)\s+model/i.test(line);
    }

    // Build sections
    const sections = [];
    let currentSection = null;

    lines.forEach((line) => {
      if (isHeading(line)) {
        // Start new section
        currentSection = {
          heading: line.replace(/:$/, ''),
          items: []
        };
        sections.push(currentSection);
      } else if (isInfoNote(line)) {
        // Special info note
        sections.push({ note: line });
        currentSection = null;
      } else if (currentSection) {
        currentSection.items.push(line);
      } else {
        // No section yet — create an implicit features section
        if (sections.length === 0 || sections[sections.length - 1].note) {
          currentSection = { heading: null, items: [line] };
          sections.push(currentSection);
        } else if (sections[sections.length - 1].items) {
          sections[sections.length - 1].items.push(line);
        }
      }
    });

    // Render the structured description as clean semantic HTML
    let html = '';

    sections.forEach(section => {
      if (section.note) {
        html += `<blockquote>${section.note}</blockquote>`;
        return;
      }

      if (section.heading) {
        html += `<h4>${section.heading}</h4>`;
      }

      if (section.items && section.items.length > 0) {
        const avgLength = section.items.reduce((sum, item) => sum + item.length, 0) / section.items.length;

        if (avgLength < 60 && section.items.length > 1) {
          html += '<ul>';
          section.items.forEach(item => {
            html += `<li>${item}</li>`;
          });
          html += '</ul>';
        } else {
          section.items.forEach(item => {
            html += `<p>${item}</p>`;
          });
        }
      }
    });

    container.innerHTML = html;
  }
})();

// ==========================================
// Wishlist (Local Storage)
// ==========================================
(function () {
  'use strict';

  const STORAGE_KEY = 'brutalist_wishlist';

  // --- Helpers ---
  function getWishlist() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch (e) {
      return [];
    }
  }

  function saveWishlist(list) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
  }

  function isInWishlist(handle) {
    return getWishlist().includes(handle);
  }

  function toggleWishlist(handle) {
    const list = getWishlist();
    const idx = list.indexOf(handle);
    if (idx > -1) {
      list.splice(idx, 1);
    } else {
      list.push(handle);
    }
    saveWishlist(list);
    updateAllUI();
    return idx === -1; // true = added, false = removed
  }

  // --- Update all toggle buttons + counters ---
  function updateAllUI() {
    const list = getWishlist();
    const count = list.length;

    // Update all toggle buttons
    document.querySelectorAll('[data-wishlist-toggle]').forEach(btn => {
      const handle = btn.dataset.productHandle;
      const isActive = list.includes(handle);
      btn.classList.toggle('is-active', isActive);
      btn.setAttribute('aria-label', isActive ? 'Von Merkliste entfernen' : 'Zur Merkliste hinzufügen');

      // Update text on PDP wishlist button
      const textEl = btn.querySelector('[data-wishlist-text]');
      if (textEl) {
        textEl.textContent = isActive ? 'Auf der Merkliste' : 'Zur Merkliste';
      }
    });

    // Update header counter
    const headerCount = document.querySelector('[data-wishlist-header-count]');
    if (headerCount) {
      headerCount.textContent = count;
      headerCount.style.display = count > 0 ? 'flex' : 'none';
    }

    // Update mobile menu counter
    const mobileCount = document.querySelector('[data-wishlist-mobile-count]');
    if (mobileCount) {
      mobileCount.textContent = count;
    }

    // Update wishlist page count text
    const countText = document.querySelector('[data-wishlist-count-text]');
    if (countText) {
      countText.textContent = count === 1 ? '1 Artikel' : `${count} Artikel`;
    }
  }

  // --- Init toggle buttons ---
  function initToggleButtons() {
    document.querySelectorAll('[data-wishlist-toggle]').forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        const handle = btn.dataset.productHandle;
        if (!handle) return;

        const added = toggleWishlist(handle);

        // Small animation only for product card heart icons (not PDP full-width button)
        if (btn.classList.contains('product-card__wishlist-btn')) {
          btn.style.transform = 'scale(1.2)';
          setTimeout(() => {
            btn.style.transform = '';
          }, 200);
        }
      });
    });
  }

  // --- Wishlist Page: Load products ---
  async function loadWishlistPage() {
    const grid = document.querySelector('[data-wishlist-grid]');
    const empty = document.querySelector('[data-wishlist-empty]');
    if (!grid) return; // Not on wishlist page

    const list = getWishlist();

    if (list.length === 0) {
      empty.style.display = 'block';
      grid.style.display = 'none';
      return;
    }

    // Show loading
    empty.style.display = 'none';
    grid.style.display = 'grid';
    grid.innerHTML = '<div class="wishlist-page__loading">Laden...</div>';

    // Fetch products
    const cards = [];

    for (const handle of list) {
      try {
        const res = await fetch(`/products/${handle}.json`);
        if (!res.ok) {
          // Product no longer exists, remove from list
          const updated = getWishlist().filter(h => h !== handle);
          saveWishlist(updated);
          continue;
        }
        const data = await res.json();
        const product = data.product;

        const imageUrl = product.image
          ? product.image.src.replace(/\.([a-z]+)$/, '_600x.$1')
          : '';

        const price = (product.variants[0].price / 1).toLocaleString('de-DE', {
          style: 'currency',
          currency: 'EUR'
        });

        cards.push(`
          <div class="wishlist-card" data-wishlist-card data-handle="${handle}">
            <a href="/products/${handle}" class="wishlist-card__link">
              <div class="wishlist-card__media">
                ${imageUrl ? `<img src="${imageUrl}" alt="${product.title}" loading="lazy">` : ''}
              </div>
              <div class="wishlist-card__info">
                <p class="wishlist-card__vendor">${product.vendor || ''}</p>
                <h3 class="wishlist-card__title">${product.title}</h3>
                <p class="wishlist-card__price">${price}</p>
              </div>
            </a>
            <button class="wishlist-card__remove" data-wishlist-remove="${handle}" aria-label="Von Merkliste entfernen">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
            </button>
          </div>
        `);
      } catch (err) {
        console.error(`Failed to load product: ${handle}`, err);
      }
    }

    grid.innerHTML = cards.join('');

    // Bind remove buttons
    grid.querySelectorAll('[data-wishlist-remove]').forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        const handle = btn.dataset.wishlistRemove;
        const card = btn.closest('[data-wishlist-card]');

        // Animate out
        if (card) {
          card.style.transition = 'opacity 0.3s ease, transform 0.3s ease';
          card.style.opacity = '0';
          card.style.transform = 'scale(0.95)';
        }

        setTimeout(() => {
          toggleWishlist(handle);
          if (card) card.remove();

          // Check if empty
          const remaining = getWishlist();
          if (remaining.length === 0) {
            grid.style.display = 'none';
            empty.style.display = 'block';
          }

          updateAllUI();
        }, 300);
      });
    });
  }

  // --- Init ---
  updateAllUI();
  initToggleButtons();
  loadWishlistPage();
})();

// ==========================================
// Hero Collection Grid — Swipe Indicator
// ==========================================
(function () {
  'use strict';

  const scroller = document.querySelector('.hero-grid__items');
  const indicator = document.querySelector('.hero-grid__swipe-indicator');
  if (!scroller || !indicator) return;

  const dots = indicator.querySelectorAll('.hero-grid__swipe-dot');
  if (!dots.length) return;

  let ticking = false;

  function updateDots() {
    const items = scroller.querySelectorAll('.hero-grid__item');
    if (!items.length) return;

    const scrollLeft = scroller.scrollLeft;
    const containerWidth = scroller.offsetWidth;
    const center = scrollLeft + containerWidth / 2;

    let closest = 0;
    let minDist = Infinity;

    items.forEach(function (item, i) {
      const itemCenter = item.offsetLeft + item.offsetWidth / 2;
      const dist = Math.abs(center - itemCenter);
      if (dist < minDist) {
        minDist = dist;
        closest = i;
      }
    });

    dots.forEach(function (dot, i) {
      dot.classList.toggle('is-active', i === closest);
    });

    if (scrollLeft > 10) {
      indicator.classList.add('is-scrolled');
    }
  }

  scroller.addEventListener('scroll', function () {
    if (!ticking) {
      requestAnimationFrame(function () {
        updateDots();
        ticking = false;
      });
      ticking = true;
    }
  }, { passive: true });

  updateDots();
})();

// ==========================================
// Trust Bar — Swipe Indicator
// ==========================================
(function () {
  'use strict';

  var scroller = document.querySelector('.trust-bar__grid');
  var indicator = document.querySelector('.trust-bar__swipe-indicator');
  if (!scroller || !indicator) return;

  var dots = indicator.querySelectorAll('.trust-bar__swipe-dot');
  if (!dots.length) return;

  var ticking = false;

  function updateDots() {
    var items = scroller.querySelectorAll('.trust-bar__item');
    if (!items.length) return;

    var sl = scroller.scrollLeft;
    var cw = scroller.offsetWidth;
    var center = sl + cw / 2;
    var closest = 0;
    var minDist = Infinity;

    items.forEach(function (item, i) {
      var d = Math.abs(center - (item.offsetLeft + item.offsetWidth / 2));
      if (d < minDist) { minDist = d; closest = i; }
    });

    dots.forEach(function (dot, i) {
      dot.classList.toggle('is-active', i === closest);
    });

    if (sl > 10) indicator.classList.add('is-scrolled');
  }

  scroller.addEventListener('scroll', function () {
    if (!ticking) {
      requestAnimationFrame(function () { updateDots(); ticking = false; });
      ticking = true;
    }
  }, { passive: true });

  updateDots();
})();

/* --- Countdown Timer --- */
(function () {
  var el = document.querySelector('[data-countdown]');
  if (!el) return;

  var raw = el.getAttribute('data-countdown-date');
  if (!raw) return;

  var target = new Date(raw.replace(' ', 'T') + ':00').getTime();
  var daysEl = el.querySelector('[data-countdown-days]');
  var hoursEl = el.querySelector('[data-countdown-hours]');
  var minsEl = el.querySelector('[data-countdown-minutes]');
  var secsEl = el.querySelector('[data-countdown-seconds]');

  function pad(n) { return n < 10 ? '0' + n : String(n); }

  function tick() {
    var now = Date.now();
    var diff = Math.max(0, target - now);

    var d = Math.floor(diff / 86400000);
    var h = Math.floor((diff % 86400000) / 3600000);
    var m = Math.floor((diff % 3600000) / 60000);
    var s = Math.floor((diff % 60000) / 1000);

    daysEl.textContent = pad(d);
    hoursEl.textContent = pad(h);
    minsEl.textContent = pad(m);
    secsEl.textContent = pad(s);

    if (diff > 0) requestAnimationFrame(tick);
  }

  tick();
})();
